export let FedopsInteractions = /*#__PURE__*/function (FedopsInteractions) {
  FedopsInteractions["BOOKINGS_VIEWER_CACHE"] = "bookings-viewer-cache";
  return FedopsInteractions;
}({});
//# sourceMappingURL=consts.js.map